const B = "/brand";
export const IMG = {
  hero: `${B}/atmos3.jpg`,      // signature gold/navy ink swirl
  office: `${B}/atmos2.jpg`,    // navy stone texture (vertical crops)
  backdrop: `${B}/atmos1.jpg`,  // navy stone texture
  texture: `${B}/atmos4.jpg`,
};
export const LOGO = {
  white: `${B}/logo_white.png`,
  navy: `${B}/logo_navy.png`,
  monogram: `${B}/monograma.jpg`,
  monogramWhite: `${B}/monograma_white.png`,
};
export const PHOTOS = {
  lucas: `${B}/lucas.jpg`,
  rodrigo: `${B}/rodrigo.jpg`,
};
